(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3034],{

/***/ 40537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ getOnlineLoadBookingPageLayout; }
/* harmony export */ });
/* unused harmony export getOnlineLoadBookingStaticProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_faq_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99891);
/* harmony import */ var components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62307);




var getOnlineLoadBookingPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__/* .useDefaultTopLayout */ .E;
var getOnlineLoadBookingStaticProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var faqs;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _vahak_core_dist_services_faq_service__WEBPACK_IMPORTED_MODULE_1__/* .FaqService.getFaqsByCateg */ .P.getFaqsByCateg({
                        categSlug: "booking-loads"
                    });
                case 2:
                    faqs = _ctx.sent.faqs;
                    return _ctx.abrupt("return", {
                        faqs: faqs
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOnlineLoadBookingStaticProps() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 51334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ online_load_booking_OnlineLoadBooking; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/service-pages/online-load-booking/OnlineLoadBooking.module.scss
var OnlineLoadBooking_module = __webpack_require__(1871);
var OnlineLoadBooking_module_default = /*#__PURE__*/__webpack_require__.n(OnlineLoadBooking_module);
// EXTERNAL MODULE: ./components/service-pages/service-data/ServiceData.ts
var ServiceData = __webpack_require__(65962);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ./components/service-pages/common/features/Features.tsx
var Features = __webpack_require__(91299);
// EXTERNAL MODULE: ./components/service-pages/common/achievements/Achievements.tsx
var Achievements = __webpack_require__(16609);
// EXTERNAL MODULE: ./components/service-pages/common/hero-section/HeroSection.tsx
var HeroSection = __webpack_require__(46523);
// EXTERNAL MODULE: ./components/service-pages/common/how-it-works/HowItWorks.tsx
var HowItWorks = __webpack_require__(42326);
// EXTERNAL MODULE: ./components/service-pages/common/faq/Faq.tsx + 1 modules
var Faq = __webpack_require__(71729);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/service-pages/types-of-loads/TypesOfLoads.module.scss
var TypesOfLoads_module = __webpack_require__(30712);
var TypesOfLoads_module_default = /*#__PURE__*/__webpack_require__.n(TypesOfLoads_module);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../core/dist/icons/arrow-right-white.svg
var arrow_right_white = __webpack_require__(89905);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
;// CONCATENATED MODULE: ./components/service-pages/types-of-loads/TypesOfLoads.tsx







//Icons




var TypesOfLoads = function(param) {
    var loadTypes = param.loadTypes, sectionTitle = param.sectionTitle, sectionText = param.sectionText;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var ref = (0,react.useState)(0), isActive = ref[0], setisActive = ref[1];
    var t = (0,esm/* useTranslation */.$G)("servicePages").t;
    var handleIsActive = function(e) {
        setisActive(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (TypesOfLoads_module_default()).main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((TypesOfLoads_module_default()).conainer, "container"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TypesOfLoads_module_default()).heading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: sectionTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: sectionText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TypesOfLoads_module_default()).lorryTypesBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TypesOfLoads_module_default()).lorryTypesNav,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: loadTypes.map(function(data) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: isActive === data.id ? (TypesOfLoads_module_default()).active : "",
                                        onClick: function() {
                                            return handleIsActive(data.id);
                                        },
                                        children: data.type
                                    }, data.id);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TypesOfLoads_module_default()).lorryTypeCardWrap,
                            children: loadTypes.map(function(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((TypesOfLoads_module_default()).lorryTypeCard, isActive === data.id ? (TypesOfLoads_module_default()).active : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (TypesOfLoads_module_default()).lorryImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TypesOfLoads_module_default()).imgBox,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                    src: data.image,
                                                    layout: "responsive",
                                                    alt: data.type,
                                                    width: isMobile ? "230" : "755",
                                                    height: isMobile ? "148" : "460"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (TypesOfLoads_module_default()).lorryText,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: data.type
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: (TypesOfLoads_module_default()).count,
                                                    children: data.count
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TypesOfLoads_module_default()).label,
                                                    children: [
                                                        t("servicePages:online-load-booking.TypesOfLoads.postings-of"),
                                                        " ",
                                                        data.type,
                                                        " ",
                                                        t("servicePages:online-load-booking.TypesOfLoads.on-Vahak")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TypesOfLoads_module_default()).topStateRow,
                                                    children: data.topStates && data.topStates.map(function(topState, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (TypesOfLoads_module_default()).stateCol,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (TypesOfLoads_module_default()).stateCard,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                                        src: topState.image,
                                                                        layout: "responsive",
                                                                        alt: topState.state,
                                                                        width: isMobile ? "100" : "170",
                                                                        height: isMobile ? "79" : "134"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: topState.state
                                                                    })
                                                                ]
                                                            })
                                                        }, index);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (TypesOfLoads_module_default()).label,
                                                    children: [
                                                        " ",
                                                        t("servicePages:online-load-booking.TypesOfLoads.top-locations-for"),
                                                        " ",
                                                        data.type
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TypesOfLoads_module_default()).bookBtnWrapper,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: data.btnURL,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            target: "_blank",
                                                            onClick: function() {
                                                                (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_load_booking */.wQ.Servicepage_online_load_booking, {
                                                                    value: event_names/* GA4ServicePageOnlineLoadBookingEventValues.type_of_truck_loads_find_now */.Iv.type_of_truck_loads_find_now
                                                                });
                                                            },
                                                            children: [
                                                                t("servicePages:online-load-booking.TypesOfLoads.find-loads-now"),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {})
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, data.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var types_of_loads_TypesOfLoads = (TypesOfLoads);

// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ./constants/breadcrumbs-constants.ts
var breadcrumbs_constants = __webpack_require__(96080);
// EXTERNAL MODULE: ./components/service-pages/common/service-information/ServiceInformation.tsx
var ServiceInformation = __webpack_require__(35778);
;// CONCATENATED MODULE: ./components/service-pages/online-load-booking/OnlineLoadBooking.tsx



















var metaData = {
    title: "Online Load Booking For Trucks in India at 0% Commission | Vahak",
    description: "Make instant loads bookings and grow your transportation business with India's largest online marketplace, Vahak. Book now and join our #1 community today.",
    keywords: "load booking,online load booking,load for truck,truck load,book load,transport load,book truck loads online,online loads for trucks,online truck load booking,online truck loads,booking loads for trucks,find truck loads online,booking loads,load booking app,lorry load booking app,lorry load booking,online lorry load booking",
    canonicalUrl: "https://www.vahak.in/online-load-booking",
    schemaOrgJsonUrl: "/online-load-booking",
    ogImgSrc: "https://d3ib4ot6oar1ep.cloudfront.net/1920/75/webp/online-load-booking-vahak_desktop.png",
    ogImgAltText: "Online Load Booking",
    breadcrumbList: (0,breadcrumbs_constants/* breadcrumbsConstants */.U)({}).onlineLoadBooking
};
var OnlineLoadBooking = function(param) {
    var faqs = param.faqs;
    var t = (0,esm/* useTranslation */.$G)("servicePages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                title: metaData.title,
                description: metaData.description,
                keywords: metaData.keywords,
                canonicalUrl: metaData.canonicalUrl,
                ogUrl: metaData.canonicalUrl,
                ogImgSrc: metaData.ogImgSrc,
                ogImgAltText: metaData.ogImgAltText,
                schemaOrgJsonUrl: metaData.schemaOrgJsonUrl,
                breadcrumbList: metaData.breadcrumbList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (OnlineLoadBooking_module_default()).main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection/* default */.Z, {
                        bannerTitle: t("servicePages:online-load-booking.hero-section.title"),
                        bannerText: t("servicePages:online-load-booking.hero-section.bannerText"),
                        hrefURL: "".concat(routeStrings/* ROUTES.marketplace.getUrl */.Z.marketplace.getUrl("load"), "?").concat(misc/* SOURCE_UTM */.vq, "=").concat(Pages/* PageTypes.ONLINE_LOAD_BOOKING */.c.ONLINE_LOAD_BOOKING),
                        hrefLabel: t("servicePages:online-load-booking.hero-section.hrefLabel"),
                        onLinkClick: function() {
                            (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_load_booking */.wQ.Servicepage_online_load_booking, {
                                value: event_names/* GA4ServicePageOnlineLoadBookingEventValues.book_loads_now */.Iv.book_loads_now
                            });
                        },
                        // srcSetURL={`${IMG_BASE_URL}/online-load-booking-vahak_desktop_3x.png 1473w, ${IMG_BASE_URL}/online-load-booking-vahak_desktop_2x.png 982w, ${IMG_BASE_URL}/online-load-booking-vahak_desktop.png 491w, ${IMG_BASE_URL}/online-load-booking-vahak_mobile_3x.png 828w, ${IMG_BASE_URL}/online-load-booking-vahak_mobile_2x.png 552w, ${IMG_BASE_URL}/online-load-booking-vahak_mobile.png 276w`}
                        srcURL: "online-load-booking-vahak_desktop.png",
                        altText: "a mobile phone with a truck and boxes",
                        imgboxClass: (OnlineLoadBooking_module_default()).herosectionImageBox
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Achievements/* default */.Z, {
                        achievementData: (0,ServiceData/* useOlbAchievement */.D1)(),
                        sectionTitle: t("servicePages:online-load-booking.achievements.sectionTitle"),
                        sectionText: t("servicePages:online-load-booking.achievements.sectionText")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceInformation/* default */.Z, {
                        heading: t("servicePages:online-load-booking.online-load-booking-benefits.heading"),
                        sectionTitle: t("servicePages:online-load-booking.online-load-booking-benefits.title"),
                        sectionText: t("servicePages:online-load-booking.online-load-booking-benefits.description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceInformation/* default */.Z, {
                        heading: t("servicePages:online-load-booking.load-booking-available-in-cities.heading"),
                        sectionTitle: t("servicePages:online-load-booking.load-booking-available-in-cities.title"),
                        sectionText: t("servicePages:online-load-booking.load-booking-available-in-cities.description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Features/* default */.Z, {
                        features: (0,ServiceData/* useOlbFeatures */.vF)(),
                        sectionTitle: t("servicePages:online-load-booking.features.sectionTitle"),
                        ctaLink: "".concat(routeStrings/* ROUTES.marketplace.getUrl */.Z.marketplace.getUrl("load")),
                        ctaLabel: t("servicePages:online-load-booking.features.ctaLabel"),
                        onCtaClick: function() {
                            (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_load_booking */.wQ.Servicepage_online_load_booking, {
                                value: event_names/* GA4ServicePageOnlineLoadBookingEventValues.start_booking_now */.Iv.start_booking_now
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
                        howitwork: (0,ServiceData/* useOlbHowItworkData */.BO)(),
                        sectionTitle: t("servicePages:online-load-booking.HowItWorks.sectionTitle"),
                        sectionText: t("servicePages:online-load-booking.HowItWorks.sectionText"),
                        tabAppNav: t("servicePages:online-load-booking.HowItWorks.tabAppNav"),
                        tabWebNav: t("servicePages:online-load-booking.HowItWorks.tabWebNav"),
                        onAppTabChange: function() {
                            (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_load_booking */.wQ.Servicepage_online_load_booking, {
                                value: event_names/* GA4ServicePageOnlineLoadBookingEventValues.mobile_app */.Iv.mobile_app
                            });
                        },
                        onWebTabChange: function() {
                            (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Servicepage_online_load_booking */.wQ.Servicepage_online_load_booking, {
                                value: event_names/* GA4ServicePageOnlineLoadBookingEventValues.web */.Iv.web
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(types_of_loads_TypesOfLoads, {
                        loadTypes: (0,ServiceData/* useLoadTypesData */.eu)(),
                        sectionTitle: t("servicePages:online-load-booking.TypesOfLoads.sectionTitle"),
                        sectionText: t("servicePages:online-load-booking.TypesOfLoads.sectionText")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq/* default */.Z, {
                        faqs: faqs,
                        sectionTitle: t("servicePages:online-load-booking.Faq.sectionTitle"),
                        sectionText: t("servicePages:online-load-booking.Faq.sectionText")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var online_load_booking_OnlineLoadBooking = (OnlineLoadBooking);


/***/ }),

/***/ 1871:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"OnlineLoadBooking_main__gooFw","herosectionImageBox":"OnlineLoadBooking_herosectionImageBox__vrwUt"};

/***/ }),

/***/ 30712:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"TypesOfLoads_main__aUapC","heading":"TypesOfLoads_heading___Rt1v","lorryTypeCardWrap":"TypesOfLoads_lorryTypeCardWrap__NiNto","lorryTypesNav":"TypesOfLoads_lorryTypesNav__wLHkQ","lorryTypeCard":"TypesOfLoads_lorryTypeCard__5oaNf","lorryText":"TypesOfLoads_lorryText__BIY6n","bookBtnWrapper":"TypesOfLoads_bookBtnWrapper__MKVmR","imgBox":"TypesOfLoads_imgBox__42l0h","topStateRow":"TypesOfLoads_topStateRow__TUlCu","count":"TypesOfLoads_count__oDpDu","label":"TypesOfLoads_label__3o0cZ","active":"TypesOfLoads_active__ahpmr","lorryImage":"TypesOfLoads_lorryImage__wt_Vy","fadeInActive":"TypesOfLoads_fadeInActive__Kyor7","stateCol":"TypesOfLoads_stateCol__gfXKt","stateCard":"TypesOfLoads_stateCard__Hxx0C"};

/***/ })

}]);